import { render, staticRenderFns } from "./ProductListCardCarousel.vue?vue&type=template&id=2005a2a9&scoped=true&"
import script from "./ProductListCardCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductListCardCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005a2a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
